import ModalBottomNotificationOptions from '@/interfaces/modal-bottom-notification-options'
import ModalIframeOptions from '@/interfaces/modal-iframe-options'
import { ModalImage } from './modal-image.model'
import { MyCoupon } from './my-coupon.model'
import { StepEditMobile } from './step-edit-mobile.model'
import ModalBannerOptions from '@/interfaces/modal-banner-options'

export const modalOptionsInternetError: ModalBottomNotificationOptions = {
  classNameHeader: 'modal-internet-error',
  image: ModalImage.WARNING_NO_INTERNET_ICON,
  body: {
    title: 'ไม่เชื่อมต่ออินเตอร์เน็ต',
    description: 'กรุณาตรวจสอบ และลองอีกครั้ง',
  },
  actionOptions: [
    {
      text: 'ลองอีกครั้ง',
      color: '#FFFFFF',
      backgroundColor: '#00BCB4',
      action: () => {
        if (navigator.onLine) {
          location.reload()
        }
      },
    },
  ],
}

export const modalOptionsRequestTimeout: ModalBottomNotificationOptions = {
  classNameHeader: 'modal-request-timeout',
  image: ModalImage.WARNING_REQUEST_TIMEOUT_ICON,
  body: {
    title: 'คำร้องขอหมดเวลา',
    description: 'คำขอนี้ใช้เวลาดำเนินการนานเกินไป</br>กรุณาลองอีกครั้ง',
  },
  actionOptions: [
    {
      text: 'ลองอีกครั้ง',
      color: '#FFFFFF',
      backgroundColor: '#00BCB4',
      action: () => {
        if (navigator.onLine) {
          location.reload()
        }
      },
    },
  ],
}

export const modalOptionsConfirmationEditProfile = (store: any): ModalBottomNotificationOptions => {
  return {
    classNameHeader: 'modal-confirmation-edit-profile',
    image: ModalImage.WARNING_CONFIRMATION_ICON,
    body: {
      title: 'คุณยังไม่ได้บันทึกข้อมูล',
      description: 'คุณต้องการที่จะออกจากหน้านี้และยกเลิกการบันทึกหรือไม่',
    },
    actionOptions: [
      {
        text: 'ยกเลิก',
        color: '',
        backgroundColor: '',
        action: () => {
          store.dispatch('modalNotification/onClose')
          store.dispatch('modalEditProfile/onClose')
        },
      },
      {
        text: 'แก้ไขต่อ',
        color: '#FFFFFF',
        backgroundColor: '#00BCB4',
        action: () => {
          store.dispatch('modalNotification/onClose')
        },
      },
    ],
  }
}

export const modalOptionsExceededRateLimit = (
  store: any,
  isBackToEditProfilePage?: boolean
): ModalBottomNotificationOptions => {
  return {
    classNameHeader: 'modal-exceeded-rate-limit',
    image: ModalImage.WARNING_NOTIFICATION_ICON,
    body: {
      title: 'คุณแก้ไขเบอร์โทรศัพท์มือถือเกินจำนวนครั้งที่กำหนด',
      description: 'กรุณาทำรายการใหม่อีกครั้งในวันถัดไป',
    },
    actionOptions: [
      {
        text: 'ตกลง',
        color: '#FFFFFF',
        backgroundColor: '#00BCB4',
        action: () => {
          store.dispatch('modalNotification/onClose')
          if (isBackToEditProfilePage) store.dispatch('modalEditMobile/onClose')
        },
      },
    ],
  }
}

export const modalOptionsTooManyRequest = (store: any): ModalBottomNotificationOptions => {
  return {
    classNameHeader: 'modal-exceeded-rate-limit',
    image: ModalImage.WARNING_NOTIFICATION_ICON,
    body: {
      title: 'ขอ OTP เกินจำนวนครั้งที่กำหนด',
      description: 'กรุณาทำรายการอีกครั้งในอีก 1 นาทีถัดไป',
    },
    actionOptions: [
      {
        text: 'ตกลง',
        color: '#FFFFFF',
        backgroundColor: '#00BCB4',
        action: () => {
          store.dispatch('modalNotification/onClose')
        },
      },
    ],
  }
}

export const modalOptionsSubmitSucceed = (store: any): ModalBottomNotificationOptions => {
  return {
    classNameHeader: 'modal-submit-succeed',
    image: ModalImage.INFO_NOTIFICATION_ICON,
    body: {
      title: 'บันทึกสำเร็จ',
    },
    actionOptions: [
      {
        text: 'สำเร็จ',
        color: '#FFFFFF',
        backgroundColor: '#00BCB4',
        action: () => {
          store.dispatch('modalNotification/onClose')
          store.dispatch('modalEditProfile/onClose')
        },
      },
    ],
  }
}

export const modalOptionsSubmitError = (store: any): ModalBottomNotificationOptions => {
  return {
    classNameHeader: 'modal-submit-error',
    image: ModalImage.WARNING_NOTIFICATION_ICON,
    body: {
      title: 'ขออภัย มีบางอย่างผิดพลาด',
      description: 'กรุณาลองใหม่อีกครั้ง',
    },
    actionOptions: [
      {
        text: 'ตกลง',
        color: '#FFFFFF',
        backgroundColor: '#00BCB4',
        action: () => {
          store.dispatch('modalNotification/onClose')
          store.dispatch('modalEditProfile/onClose')
        },
      },
    ],
  }
}

export const getUrlModalOptionsMyCoupon = (id?: string, menu?: 'lotus' | 'lifestyle', submenu?: 'offer' | 'coupon', subtype?: string, customerType?: string, accessToken?: string) => {
  const queryParam = `${menu ? '/' + menu : ''}${submenu ? '/' + submenu : ''}${subtype ? '/' + subtype : ''}${id ? '/' + id : ''}?channel=line${customerType === 'online' ? '&customerType=online' : ''}${accessToken ? `&accessToken=${accessToken}` : ''}`
  return `${process.env.VUE_APP_MY_COUPON_URL}${queryParam}`
}

export const modalOptionsCouponBZB: ModalIframeOptions = {
  classNameHeader: 'modal-coupon-gift',
  title: MyCoupon.COUPON_LIFESTYLE_TITLE,
  url: getUrlModalOptionsMyCoupon(undefined, 'lifestyle', 'offer', undefined, undefined, undefined),
}

export const modalOptionsCouponLotus: ModalIframeOptions = {
  classNameHeader: 'modal-coupon-exchanged',
  title: MyCoupon.COUPON_LOTUS_TITLE,
  url: getUrlModalOptionsMyCoupon(undefined, 'lotus', 'offer', undefined, undefined, undefined),
}

export const modalOptionsOtpExceededRateLimit = (store: any): ModalBottomNotificationOptions => {
  return {
    classNameHeader: 'modal-option-exceed-rate-limit',
    image: ModalImage.WARNING_NOTIFICATION_ICON,
    body: {
      title: 'คุณกรอกรหัส OTP<br> เกินจำนวนครั้งที่กำหนด',
      description: 'กรุณาทำรายการอีกครั้ง',
    },
    actionOptions: [
      {
        text: 'ตกลง',
        color: '#FFFFFF',
        backgroundColor: '#00BCB4',
        action: () => {
          if(store.state.modalEditMobile.level === 'L2'){
            store.dispatch('modalNotification/onClose')
            store.commit('modalEditMobile/updateStep', StepEditMobile.INPUT_NEW_MOBILE)
          } else {
            store.dispatch('modalNotification/onClose')
            store.commit('modalEditMobile/updateStep', '')
          }
        },
      },
    ],
  }
}

export const modalOtpExceededRateLimit = (store: any): ModalBottomNotificationOptions => {
  return {
    classNameHeader: 'modal-option-exceed-rate-limit',
    image: ModalImage.WARNING_NOTIFICATION_ICON,
    body: {
      title: 'สำหรับผู้ที่ผูกบัญชีทรูมันนี่',
      description:
        'ระบบจะยกเลิกการผูกบัญชีหลังแก้ไข คุณสามารถผูกบัญชีได้อีกครั้งด้วยเบอร์โทรศัพท์มือถือใหม่',
    },
    actionOptions: [
      {
        text: 'ตกลง',
        color: '#FFFFFF',
        backgroundColor: '#00BCB4',
        action: () => {
          store.dispatch('modalNotification/onClose')
        },
      },
    ],
  }
}

export const modalOptionsOtpFailed = (
  store: any,
  callback: any
): ModalBottomNotificationOptions => {
  return {
    classNameHeader: 'modal-option-otp-failed',
    image: ModalImage.WARNING_NOTIFICATION_ICON,
    body: {
      title: 'รหัส OTP ไม่ถูกต้อง',
      description: 'กรุณากรอกใหม่อีกครั้ง',
    },
    actionOptions: [
      {
        text: 'ตกลง',
        color: '#FFFFFF',
        backgroundColor: '#00BCB4',
        action: () => {
          store.dispatch('modalNotification/onClose')

          if (callback && callback instanceof Function) callback()
        },
      },
    ],
  }
}
export const modalOptionsOtpTimeout = (
  store: any,
  callback: any
): ModalBottomNotificationOptions => {
  return {
    classNameHeader: 'modal-option-otp-timeout',
    image: ModalImage.WARNING_NOTIFICATION_ICON,
    body: {
      title: 'รหัส OTP ของคุณ</br>หมดเวลาใช้งาน',
      description: 'กรุณาคลิกปุ่ม "ส่งรหัสใหม่" เพื่อดำเนินการต่อ',
    },
    actionOptions: [
      {
        text: 'ตกลง',
        color: '#FFFFFF',
        backgroundColor: '#00BCB4',
        action: () => {
          store.dispatch('modalNotification/onClose')

          if (callback && callback instanceof Function) callback()
        },
      },
    ],
  }
}

export const modalOptionsUpdateSucceed = (
  store: any,
  callback?: any
): ModalBottomNotificationOptions => {
  return {
    classNameHeader: 'modal-update-succeed',
    image: ModalImage.INFO_NOTIFICATION_ICON,
    body: {
      title: 'แก้ไขสำเร็จ',
    },
    actionOptions: [
      {
        text: 'ปิด',
        color: '#FFFFFF',
        backgroundColor: '#00BCB4',
        action: () => {
          store.dispatch('modalNotification/onClose')

          if (callback && callback instanceof Function) callback()
        },
      },
    ],
  }
}

export const modalTokenExpired = (callback: any): ModalBottomNotificationOptions => {
  return {
    classNameHeader: 'modal-internet-error',
    image: ModalImage.WARNING_TOKEN_EXPIRED_ICON,
    body: {
      title: 'ทำรายการเกินเวลากำหนด',
      description: 'กรุณาทำรายการใหม่อีกครั้ง',
    },
    actionOptions: [
      {
        text: 'ตกลง',
        color: '#FFFFFF',
        backgroundColor: '#00BCB4',
        action: () => {
          if (callback && callback instanceof Function) {
            callback()
          }
        },
      },
    ],
  }
}

export const modalOptionsDopaSubmitError = (callback: any): ModalBottomNotificationOptions => {
  return {
    classNameHeader: 'modal-option-dopa-submit-error',
    image: ModalImage.WARNING_NOTIFICATION_ICON,
    body: {
      title: 'ข้อมูลของคุณไม่ถูกต้อง',
      description: 'กรุณาตรวจสอบและกรอกข้อมูลเป็นภาษาไทย<br>ตรงตามบัตรประชาชน',
    },
    actionOptions: [
      {
        text: 'ตกลง',
        color: '#FFFFFF',
        backgroundColor: '#00BCB4',
        action: () => {
          if (callback && callback instanceof Function) callback()
        },
      },
    ],
  }
}

export const modalOptionsExceededRateLimitWithBackReEnterNumber = (
  store: any,
  callback: any
): ModalBottomNotificationOptions => {
  return {
    classNameHeader: 'modal-exceeded-rate-limit-with-back-reenter-mobile-number',
    image: ModalImage.WARNING_NOTIFICATION_ICON,
    body: {
      title: 'คุณแก้ไขเบอร์โทรศัพท์มือถือเกินจำนวนครั้งที่กำหนด',
      description: 'กรุณาทำรายการใหม่อีกครั้งในวันถัดไป',
    },
    actionOptions: [
      {
        text: 'ตกลง',
        color: '#FFFFFF',
        backgroundColor: '#00BCB4',
        action: () => {
          store.dispatch('modalNotification/onClose')
          if (callback && callback instanceof Function) callback()
        },
      },
    ],
  }
}

export const modalOptionsBanner = (eventCode: string, imageUrl?: string, destinationUrl?: string, close?: boolean, loadingLabel?: string): ModalBannerOptions => {
  return {
    classNameHeader: `modal-banner-${eventCode}`,
    image: imageUrl,
    url: destinationUrl,
    actionClose: close,
    loadingBarLabel: loadingLabel
  }
}
